import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? (process.env.NODE_ENV === "production" ? "/api" : "http://127.0.0.1:8000")
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Cierra sesión automáticamente si el servidor responde 401 (token expirado o inválido)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;